import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth.service';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { EditUserProfileComponent } from './edit-user-profile/edit-user-profile.component';
import { RoleManagementService } from 'src/app/shared/services/role-management.service';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit {
  profile: any;
  profileImg: any;
  rolestatus: any;
  loading!: boolean;
  userPermissions: any;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private apiService: AuthService,
    private snackBar: MatSnackBar,
    private router: Router,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<UserProfileComponent>,
    private roleManagementService: RoleManagementService,) {
  }

  ngOnInit(): void {
    this.loading = true;
    this.Getuser();
    this.loading = false;
    this.loadUserPermissions();
  }

  loadUserPermissions(): void {
    this.userPermissions = JSON.parse(localStorage.getItem('userPermissions') || '[]');
  }

  hasPermission(permission: string): boolean {
    return this.rolestatus.role.allow_everything == 1 || this.userPermissions.includes(permission);
  }
  // Get User data
  Getuser() {
    this.loading = true;
    this.apiService.getCurrentUser().subscribe({
      next: (res) => {
        this.profile = res.data;
        this.rolestatus = res.data
        this.profileImg = res.data.first_name.split(' ').map((name: any) => name[0]).join('').toUpperCase() + res.data.last_name.split(' ').map((name: any) => name[0]).join('').toUpperCase()
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
      },
    });
  }
  // Edit Profile Dialog
  openEditDialog(data: any): void {
    this.roleManagementService.checkUserRole().subscribe(isRoleActive => {
      if (isRoleActive) {
        const darkMode = localStorage.getItem('darkMode');
        const dialogRef = this.dialog.open(EditUserProfileComponent, {
          width: '650px',
          height: '100%',
          position: {
            right: '0',
            top: '0'
          },
          data: this.profile,
          panelClass: darkMode == 'true' ? 'dark-theme' : 'light-theme',
        });
        dialogRef.afterClosed().subscribe(result => {
          this.Getuser();
        });
      }
    });
  }
  // Chnage Password Dialog
  openPasswordDialog(): void {
    this.roleManagementService.checkUserRole().subscribe(isRoleActive => {
      if (isRoleActive) {
        const darkMode = localStorage.getItem('darkMode');
        const dialogRef = this.dialog.open(ChangePasswordComponent, {
          width: '375px',
          height: '100%',
          position: {
            right: '0',
            top: '0'
          },
          panelClass: darkMode == 'true' ? 'dark-theme' : 'light-theme',
        });
        dialogRef.afterClosed().subscribe(result => {
        });
      }
    });
  }
}